import(/* webpackMode: "eager" */ "/app/src/app/gallery/[galleryId]/page.tsx");
